<div class="publication-checklist">
	<h3>{{ title || 'CHECKLIST_FOR_PUBLICATION' | translate }}</h3>
	<div class="checklist">
		<ng-container *ngFor="let it of items; let i = index">
			<!-- 2 columns or 4 columns -->
			<div *ngIf="i % 2 === 0" class="row">
				<ng-container *ngFor="let item of items.slice(i, i + 2)">
					<bb-checklist-item [item]="item" [class.hidden]="item.hidden"></bb-checklist-item>
				</ng-container>
			</div>
		</ng-container>
	</div>
</div>
